import { render, staticRenderFns } from "./xiaohei_order_check_edit.vue?vue&type=template&id=b16c6350&scoped=true"
import script from "./xiaohei_order_check_edit.vue?vue&type=script&lang=js"
export * from "./xiaohei_order_check_edit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b16c6350",
  null
  
)

export default component.exports